import { BikeTrailAction, BikeTrailMutation } from "./types";
import axios from "axios";

export default {
    [BikeTrailAction.AUTOCOMPLETE]({commit}) {
        return new Promise((resolve, reject) => {
            commit(BikeTrailMutation.REQUEST);

            axios.get('/bike-trail/autocomplete')
                .then(resp => {
                    return resp.data;
                })
                .then(data => {
                    commit(BikeTrailMutation.SUCCESS_AUTOCOMPLETE, data);
                    resolve(data);
                })
                .catch(err => {
                    commit(BikeTrailMutation.ERROR, err.response.data || err);
                    reject(err);
                });
        });
    },
};
